import { useFetchIntegration } from "hooks";
import { getURLWithParams } from "utils/context";

export const useProductsLinkMix = params =>
  useFetchIntegration(getURLWithParams("/produtos-new", params));
